import PropTypes from "prop-types";

import { useOnClickOutside } from "../../hooks";
import { ButtonsPopupStyled } from "./styled";
import { useRef } from "react";

const ButtonsPopup = ({ visible, setVisible, children, containerRef, ...props }) => {
  const popupRef = useRef();
  useOnClickOutside(popupRef, (e) => {
    if (
      !containerRef?.current ||
      (containerRef?.current && !containerRef.current.contains(e.target))
    ) {
      setVisible(false);
    }
  });

  return (
    <ButtonsPopupStyled ref={popupRef} visible={visible} {...props}>
      {children}
    </ButtonsPopupStyled>
  );
};

ButtonsPopup.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  containerRef: PropTypes.object
};

export default ButtonsPopup;
